export default __webpack_public_path__ + "static/glass-4-dd58a0bea5eeb7fce2c2617d776a0d1e.jpg";